import { Injectable, OnDestroy } from '@angular/core';
import { ScrollDispatcher } from '@angular/cdk/overlay';
import { map, Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadByScrollTriggerService implements OnDestroy {
  #resizeObserver!: ResizeObserver;
  #resizeObserved!: HTMLElement;

  fillData$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(private scrollDispatcher: ScrollDispatcher) {}

  public initScrollTrigger(
    listContainer: HTMLElement,
    scrollerContainer: HTMLElement | Window
  ): Observable<boolean> {
    const scrollLoadTrigger$ = this.scrollDispatcher
      .ancestorScrolled(listContainer, 500)
      .pipe(
        map(() => {
          const viewportHeight = window.innerHeight;
          const contentHeight = listContainer.offsetHeight;
          const rawContentAbsoluteY: string = window
            .getComputedStyle(listContainer, null)
            .getPropertyValue('padding-top');
          let contentAbsoluteY = 0;
          if (rawContentAbsoluteY) {
            contentAbsoluteY = parseFloat(rawContentAbsoluteY);
          }
          const scrollableDistance =
            contentHeight - viewportHeight + contentAbsoluteY;
          let scrollY = window.scrollY;
          if (scrollerContainer instanceof Window) {
            scrollY = window.scrollY;
          } else {
            scrollY = scrollerContainer.scrollTop;
          }
          const remainingScrollableRatio = scrollY / scrollableDistance;
          /*            console.log('/////');
          console.log('ClientsComponent', { remainingScrollableRatio });
          console.log('ClientsComponent', { nativeElement });
          console.log('ClientsComponent', { viewportHeight });
          console.log('ClientsComponent', { contentAbsoluteY });
          console.log('ClientsComponent', { contentHeight });
          console.log('ClientsComponent', { scrollableDistance });
          console.log('ClientsComponent', { scrollY });*/
          // console.log({ remainingScrollableRatio });
          return remainingScrollableRatio > 0.75;
        })
      );
    return scrollLoadTrigger$;
  }

  public contentFillDetection(
    listContainer: HTMLElement,
    scrollerContainer: HTMLElement | Window
  ): Observable<boolean> {
    this.#resizeObserver = new ResizeObserver((entries) => {
      if (scrollerContainer instanceof Window) {
        if (listContainer.offsetHeight < scrollerContainer.innerHeight * 2) {
          this.fillData$.next(true);
        }
      } else {
        if (listContainer.offsetHeight < scrollerContainer.offsetHeight * 2) {
          this.fillData$.next(true);
        }
      }
    });
    this.#resizeObserved = listContainer;
    this.#resizeObserver.observe(listContainer);
    return this.fillData$;
  }

  ngOnDestroy(): void {
    this.#resizeObserver.disconnect();
  }
}
